// 查看会员信息 （客户购买商品清单）
<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
        <div>
          <el-card class="NumberCardWidth">
            <div class="deal flex-between">
              <div class="card-text">
                <h3>客户购买商品清单</h3>
              </div>
              <div class="card-button">
                <el-button
                  class="push-button"
                  icon="iconfont icon-fanhui"
                  plain
                  @click="NvagetToLookMenber"
                  >返回基本信息</el-button
                >
              </div>
            </div>
            <div class="NumberTable">
              <!-- table列表 -->
              <Table
                 @TouchTheBottom="TouchTheBottom"
                :PagesData="paging"
                :tableData="list.tbody"
                :configTable="list.thead"
                :config="list"
              ></Table>
            </div>
          </el-card>
        </div>
        <!-- 右侧列表相关链接 -->
        <!-- 使用封装的组件 -->
        <div class="PagesContentRight">
          <RightCard></RightCard>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetSaleProductList } from "@/api/viewMemberModule";
import Table from "/src/components/NumberTable/index.vue";
import { getcpyNo } from "@/utils/auth";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages:2,
        Loading:true
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "SKU",
            prop: "sku",
            width: 150,
          },
          {
            label: "商品条码",
            prop: "barCode",
            width: 200,
          },
          {
            label: "购买时间",
            prop: "saleDate",
             width: 160,
          },
          {
            label: "门店",
            prop: "shopName",
          },
          {
            label: "销售单号",
            prop: "saleNo",
            width: 130,
          },
          {
            label: "品类",
            prop: "categoryCn"
          },
          {
            label: "数量",
            prop: "qty",
          },
          {
            label: "出单人",
            prop: "saleEmpName",
          },
        ],
        tbody: [],// 表格内容
      },
    };
  },
  created() {
    this.RGetSaleProductList();
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  methods: {
    RGetSaleProductList() {
      let data = {
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      };
      GetSaleProductList(data).then((res) => {
         if (res.success == true) {
          this.paging.total = res.data.total;
          this.paging.pages = res.data.pages;
          res.data.list.forEach((item, index) => {
            item.CopyIndex =
              (this.paging.page - 1) * this.paging.size + index + 1;
            item.saleDate = this.renderTime(item.saleDate);
          });
          this.list.tbody = this.list.tbody.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false
      });
    },
    renderTime(date) {
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    TouchTheBottom() {
      this.paging.page ++;
      this.RGetSaleProductList();
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth{
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  margin-left: 25px;
  height: 990px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable{
  margin-top: 40px;
}
#Shopping-list {
  height: 1500px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
